module.exports = __webpack_public_path__ + "img/carousel.a351341d.svg";